import React, { Component } from "react";
import Avatar from "../chatList/Avatar";

export default class ChatItem extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        style={{ animationDelay: `0.8s` }}
        className={`chat__item ${this.props.user ? this.props.user : ""}`}
      >
        <div className="chat__item__content">
          <div>
            {this.props.mediaType ? this.props.mediaType.includes("image") ?
              <img src={this.props.mediaURL} alt="" width="320" height="240" /> :
              <video width="320" height="240" controls>
                <source src={this.props.mediaURL} type="video/mp4" />
                <source src={this.props.mediaURL} type="video/ogg" />
                Your browser does not support the video tag.
              </video>
              : null
            }
          </div>
          <div className="chat__msg">{this.props.msg}</div>
          <div className="chat__meta">
            <span>16 mins ago</span>
            <span>Seen 1.03PM</span>
          </div>
        </div>
        <Avatar isOnline="active" image={this.props.image} />
      </div>
    );
  }
}
